import { Locales } from '@previo/core'

export type DateTimeFormats = {
  NICE_DATE: string
  NICE_DATE_SHORT: string
  NICE_DATE_WITHOUT_YEAR: string
  NICE_TIME: string
  NICE_MONTH_TEXT_DATE_AND_YEAR: string
  NICE_MONTH_TEXT_DATE_TIME_AND_YEAR: string
  NICE_DAY_TEXT_MONTH_TEXT_DATE: string
  NICE_DAY_TEXT_MONTH_TEXT_DATE_AND_YEAR: string
  NICE_DAY_TEXT_TIME: string
  NICE_DATE_TIME: string
  NICE_DATE_TIME_SHORT: string
  NICE_DATE_TIME_WITHOUT_YEAR: string
}

export const DATE_TIME_FORMATS: Record<Locales, DateTimeFormats> = {
  [Locales.CS]: {
    NICE_DATE: 'DD. MM. YYYY',
    NICE_DATE_SHORT: 'DD. MM. YY',
    NICE_DATE_WITHOUT_YEAR: 'DD. MM.',
    NICE_TIME: 'HH:mm',
    NICE_MONTH_TEXT_DATE_AND_YEAR: 'D. MMM YYYY',
    NICE_MONTH_TEXT_DATE_TIME_AND_YEAR: 'D. MMM YYYY HH:mm',
    NICE_DAY_TEXT_MONTH_TEXT_DATE: 'ddd D. MMM',
    NICE_DAY_TEXT_MONTH_TEXT_DATE_AND_YEAR: 'ddd D. MMM YYYY',
    NICE_DAY_TEXT_TIME: 'ddd H:mm',
    NICE_DATE_TIME: 'DD. MM. YYYY HH:mm',
    NICE_DATE_TIME_SHORT: 'DD. MM. YY HH:mm',
    NICE_DATE_TIME_WITHOUT_YEAR: 'DD. MM. HH:mm',
  },
  [Locales.EN]: {
    NICE_DATE: 'DD/MM/YYYY',
    NICE_DATE_SHORT: 'DD/MM/YY',
    NICE_DATE_WITHOUT_YEAR: 'D/M',
    NICE_TIME: 'HH:mm',
    NICE_MONTH_TEXT_DATE_AND_YEAR: 'DD MMM YYYY',
    NICE_MONTH_TEXT_DATE_TIME_AND_YEAR: 'DD MMM YYYY HH:mm',
    NICE_DAY_TEXT_MONTH_TEXT_DATE: 'ddd MMM D',
    NICE_DAY_TEXT_MONTH_TEXT_DATE_AND_YEAR: 'ddd MMM D, YYYY',
    NICE_DAY_TEXT_TIME: 'ddd HH:mm',
    NICE_DATE_TIME: 'DD/MM/YYYY HH:mm',
    NICE_DATE_TIME_SHORT: 'DD/MM/YY HH:mm',
    NICE_DATE_TIME_WITHOUT_YEAR: 'DD/MM HH:mm',
  },
  [Locales.HR]: {
    NICE_DATE: 'DD.MM.YYYY.',
    NICE_DATE_SHORT: 'DD.MM.YY.',
    NICE_DATE_WITHOUT_YEAR: 'DD.MM.',
    NICE_TIME: 'HH:mm',
    NICE_MONTH_TEXT_DATE_AND_YEAR: 'D. MMM YYYY.',
    NICE_MONTH_TEXT_DATE_TIME_AND_YEAR: 'D. MMM YYYY. HH:mm',
    NICE_DAY_TEXT_MONTH_TEXT_DATE: 'ddd D. MMM',
    NICE_DAY_TEXT_MONTH_TEXT_DATE_AND_YEAR: 'ddd D. MMM YYYY.',
    NICE_DAY_TEXT_TIME: 'ddd HH:mm',
    NICE_DATE_TIME: 'DD.MM.YYYY. HH:mm',
    NICE_DATE_TIME_SHORT: 'DD.MM.YY. HH:mm',
    NICE_DATE_TIME_WITHOUT_YEAR: 'DD.MM. HH:mm',
  },
  [Locales.HU]: {
    NICE_DATE: 'YYYY. MM. DD.',
    NICE_DATE_SHORT: 'YY. MM. DD.',
    NICE_DATE_WITHOUT_YEAR: 'MM. DD.',
    NICE_TIME: 'HH:mm',
    NICE_MONTH_TEXT_DATE_AND_YEAR: 'YYYY. MMM D.',
    NICE_MONTH_TEXT_DATE_TIME_AND_YEAR: 'YYYY. MMM D. HH:mm',
    NICE_DAY_TEXT_MONTH_TEXT_DATE: 'ddd MMM D.',
    NICE_DAY_TEXT_MONTH_TEXT_DATE_AND_YEAR: 'ddd YYYY. MMM D.',
    NICE_DAY_TEXT_TIME: 'ddd HH:mm',
    NICE_DATE_TIME: 'YYYY. MM. DD. HH:mm',
    NICE_DATE_TIME_SHORT: 'YY. MM. DD. HH:mm',
    NICE_DATE_TIME_WITHOUT_YEAR: 'MM. DD. HH:mm',
  },
  [Locales.PL]: {
    NICE_DATE: 'DD.MM.YYYY',
    NICE_DATE_SHORT: 'DD.MM.YY',
    NICE_DATE_WITHOUT_YEAR: 'DD.MM.',
    NICE_TIME: 'HH:mm',
    NICE_MONTH_TEXT_DATE_AND_YEAR: 'DD. MMM YYYY',
    NICE_MONTH_TEXT_DATE_TIME_AND_YEAR: 'DD. MMM YYYY HH:mm',
    NICE_DAY_TEXT_MONTH_TEXT_DATE: 'ddd DD. MMM',
    NICE_DAY_TEXT_MONTH_TEXT_DATE_AND_YEAR: 'ddd DD. MMM YYYY',
    NICE_DAY_TEXT_TIME: 'ddd HH:mm',
    NICE_DATE_TIME: 'DD.MM.YYYY HH:mm',
    NICE_DATE_TIME_SHORT: 'DD.MM.YY HH:mm',
    NICE_DATE_TIME_WITHOUT_YEAR: 'DD.MM. HH:mm',
  },
  [Locales.DE]: {
    NICE_DATE: 'DD.MM.YYYY',
    NICE_DATE_SHORT: 'DD.MM.YY',
    NICE_DATE_WITHOUT_YEAR: 'DD.MM',
    NICE_TIME: 'HH:mm',
    NICE_MONTH_TEXT_DATE_AND_YEAR: 'DD. MMM YYYY',
    NICE_MONTH_TEXT_DATE_TIME_AND_YEAR: 'DD. MMM YYYY HH:mm',
    NICE_DAY_TEXT_MONTH_TEXT_DATE: 'ddd DD. MMM',
    NICE_DAY_TEXT_MONTH_TEXT_DATE_AND_YEAR: 'ddd DD. MMM YYYY',
    NICE_DAY_TEXT_TIME: 'ddd HH:mm',
    NICE_DATE_TIME: 'DD.MM.YYYY HH:mm',
    NICE_DATE_TIME_SHORT: 'DD.MM.YY HH:mm',
    NICE_DATE_TIME_WITHOUT_YEAR: 'DD.MM. HH:mm',
  },
  [Locales.IT]: {
    NICE_DATE: 'DD/MM/YYYY',
    NICE_DATE_SHORT: 'DD/MM/YY',
    NICE_DATE_WITHOUT_YEAR: 'DD/MM',
    NICE_TIME: 'HH:mm',
    NICE_MONTH_TEXT_DATE_AND_YEAR: 'D MMM YYYY',
    NICE_MONTH_TEXT_DATE_TIME_AND_YEAR: 'D MMM YYYY HH:mm',
    NICE_DAY_TEXT_MONTH_TEXT_DATE: 'ddd D MMM',
    NICE_DAY_TEXT_MONTH_TEXT_DATE_AND_YEAR: 'ddd D MMM YYYY',
    NICE_DAY_TEXT_TIME: 'ddd H:mm',
    NICE_DATE_TIME: 'DD/MM/YYYY HH:mm',
    NICE_DATE_TIME_SHORT: 'DD/MM/YY HH:mm',
    NICE_DATE_TIME_WITHOUT_YEAR: 'DD/MM HH:mm',
  },
  [Locales.RO]: {
    NICE_DATE: 'DD.MM.YYYY',
    NICE_DATE_SHORT: 'DD.MM.YY',
    NICE_DATE_WITHOUT_YEAR: 'DD.MM',
    NICE_TIME: 'HH:mm',
    NICE_MONTH_TEXT_DATE_AND_YEAR: 'DD MMM YYYY',
    NICE_MONTH_TEXT_DATE_TIME_AND_YEAR: 'DD MMM YYYY HH:mm',
    NICE_DAY_TEXT_MONTH_TEXT_DATE: 'ddd DD MMM',
    NICE_DAY_TEXT_MONTH_TEXT_DATE_AND_YEAR: 'ddd DD MMM YYYY',
    NICE_DAY_TEXT_TIME: 'ddd HH:mm',
    NICE_DATE_TIME: 'DD.MM.YYYY HH:mm',
    NICE_DATE_TIME_SHORT: 'DD.MM.YY HH:mm',
    NICE_DATE_TIME_WITHOUT_YEAR: 'DD.MM HH:mm',
  },
  [Locales.SK]: {
    NICE_DATE: 'DD. MM. YYYY',
    NICE_DATE_SHORT: 'DD. MM. YY',
    NICE_DATE_WITHOUT_YEAR: 'DD. MM.',
    NICE_TIME: 'HH:mm',
    NICE_MONTH_TEXT_DATE_AND_YEAR: 'D. MMM YYYY',
    NICE_MONTH_TEXT_DATE_TIME_AND_YEAR: 'D. MMM YYYY HH:mm',
    NICE_DAY_TEXT_MONTH_TEXT_DATE: 'ddd D. MMM',
    NICE_DAY_TEXT_MONTH_TEXT_DATE_AND_YEAR: 'ddd D. MMM YYYY',
    NICE_DAY_TEXT_TIME: 'ddd H:mm',
    NICE_DATE_TIME: 'DD. MM. YYYY HH:mm',
    NICE_DATE_TIME_SHORT: 'DD. MM. YY HH:mm',
    NICE_DATE_TIME_WITHOUT_YEAR: 'DD. MM. HH:mm',
  },
  [Locales.UK]: {
    NICE_DATE: 'DD.MM.YYYY',
    NICE_DATE_SHORT: 'DD.MM.YY',
    NICE_DATE_WITHOUT_YEAR: 'DD.MM.',
    NICE_TIME: 'HH:mm',
    NICE_MONTH_TEXT_DATE_AND_YEAR: 'D MMM YYYY',
    NICE_MONTH_TEXT_DATE_TIME_AND_YEAR: 'D MMM YYYY HH:mm',
    NICE_DAY_TEXT_MONTH_TEXT_DATE: 'ddd D MMM',
    NICE_DAY_TEXT_MONTH_TEXT_DATE_AND_YEAR: 'ddd D MMM YYYY',
    NICE_DAY_TEXT_TIME: 'ddd H:mm',
    NICE_DATE_TIME: 'DD.MM.YYYY HH:mm',
    NICE_DATE_TIME_SHORT: 'DD.MM.YY HH:mm',
    NICE_DATE_TIME_WITHOUT_YEAR: 'DD.MM. HH:mm',
  },
  [Locales.RU]: {
    NICE_DATE: 'DD.MM.YYYY',
    NICE_DATE_SHORT: 'DD.MM.YY',
    NICE_DATE_WITHOUT_YEAR: 'DD.MM.',
    NICE_TIME: 'HH:mm',
    NICE_MONTH_TEXT_DATE_AND_YEAR: 'D MMM YYYY',
    NICE_MONTH_TEXT_DATE_TIME_AND_YEAR: 'D MMM YYYY HH:mm',
    NICE_DAY_TEXT_MONTH_TEXT_DATE: 'ddd D MMM',
    NICE_DAY_TEXT_MONTH_TEXT_DATE_AND_YEAR: 'ddd D MMM YYYY',
    NICE_DAY_TEXT_TIME: 'ddd H:mm',
    NICE_DATE_TIME: 'DD.MM.YYYY HH:mm',
    NICE_DATE_TIME_SHORT: 'DD.MM.YY HH:mm',
    NICE_DATE_TIME_WITHOUT_YEAR: 'DD.MM. HH:mm',
  },
  [Locales.ES]: {
    NICE_DATE: 'DD/MM/YYYY',
    NICE_DATE_SHORT: 'DD/MM/YY',
    NICE_DATE_WITHOUT_YEAR: 'DD/MM',
    NICE_TIME: 'HH:mm',
    NICE_MONTH_TEXT_DATE_AND_YEAR: 'D MMMM YYYY',
    NICE_MONTH_TEXT_DATE_TIME_AND_YEAR: 'D MMMM YYYY HH:mm',
    NICE_DAY_TEXT_MONTH_TEXT_DATE: 'ddd D MMMM',
    NICE_DAY_TEXT_MONTH_TEXT_DATE_AND_YEAR: 'ddd D MMMM YYYY',
    NICE_DAY_TEXT_TIME: 'ddd H:mm',
    NICE_DATE_TIME: 'DD/MM/YYYY HH:mm',
    NICE_DATE_TIME_SHORT: 'DD/MM/YY HH:mm',
    NICE_DATE_TIME_WITHOUT_YEAR: 'DD/MM HH:mm',
  },
  [Locales.BG]: {
    NICE_DATE: 'DD.MM.YYYY',
    NICE_DATE_SHORT: 'DD.MM.YY',
    NICE_DATE_WITHOUT_YEAR: 'DD.MM.',
    NICE_TIME: 'HH:mm',
    NICE_MONTH_TEXT_DATE_AND_YEAR: 'D MMMM YYYY',
    NICE_MONTH_TEXT_DATE_TIME_AND_YEAR: 'D MMMM YYYY HH:mm',
    NICE_DAY_TEXT_MONTH_TEXT_DATE: 'ddd D MMMM',
    NICE_DAY_TEXT_MONTH_TEXT_DATE_AND_YEAR: 'ddd D MMMM YYYY',
    NICE_DAY_TEXT_TIME: 'ddd H:mm',
    NICE_DATE_TIME: 'DD.MM.YYYY HH:mm',
    NICE_DATE_TIME_SHORT: 'DD.MM.YY HH:mm',
    NICE_DATE_TIME_WITHOUT_YEAR: 'DD.MM. HH:mm',
  },
  [Locales.PT]: {
    NICE_DATE: 'DD/MM/YYYY',
    NICE_DATE_SHORT: 'DD/MM/YY',
    NICE_DATE_WITHOUT_YEAR: 'DD/MM',
    NICE_TIME: 'HH:mm',
    NICE_MONTH_TEXT_DATE_AND_YEAR: 'D MMMM YYYY',
    NICE_MONTH_TEXT_DATE_TIME_AND_YEAR: 'D MMMM YYYY HH:mm',
    NICE_DAY_TEXT_MONTH_TEXT_DATE: 'ddd D MMMM',
    NICE_DAY_TEXT_MONTH_TEXT_DATE_AND_YEAR: 'ddd D MMMM YYYY',
    NICE_DAY_TEXT_TIME: 'ddd H:mm',
    NICE_DATE_TIME: 'DD/MM/YYYY HH:mm',
    NICE_DATE_TIME_SHORT: 'DD/MM/YY HH:mm',
    NICE_DATE_TIME_WITHOUT_YEAR: 'DD/MM HH:mm',
  },
  [Locales.FR]: {
    NICE_DATE: 'DD/MM/YYYY',
    NICE_DATE_SHORT: 'DD/MM/YY',
    NICE_DATE_WITHOUT_YEAR: 'DD/MM',
    NICE_TIME: 'HH:mm',
    NICE_MONTH_TEXT_DATE_AND_YEAR: 'D MMMM YYYY',
    NICE_MONTH_TEXT_DATE_TIME_AND_YEAR: 'D MMMM YYYY HH:mm',
    NICE_DAY_TEXT_MONTH_TEXT_DATE: 'ddd D MMMM',
    NICE_DAY_TEXT_MONTH_TEXT_DATE_AND_YEAR: 'ddd D MMMM YYYY',
    NICE_DAY_TEXT_TIME: 'ddd H:mm',
    NICE_DATE_TIME: 'DD/MM/YYYY HH:mm',
    NICE_DATE_TIME_SHORT: 'DD/MM/YY HH:mm',
    NICE_DATE_TIME_WITHOUT_YEAR: 'DD/MM HH:mm',
  },
  [Locales.NL]: {
    NICE_DATE: 'DD-MM-YYYY',
    NICE_DATE_SHORT: 'DD-MM-YY',
    NICE_DATE_WITHOUT_YEAR: 'DD-MM',
    NICE_TIME: 'HH:mm',
    NICE_MONTH_TEXT_DATE_AND_YEAR: 'D MMMM YYYY',
    NICE_MONTH_TEXT_DATE_TIME_AND_YEAR: 'D MMMM YYYY HH:mm',
    NICE_DAY_TEXT_MONTH_TEXT_DATE: 'ddd D MMMM',
    NICE_DAY_TEXT_MONTH_TEXT_DATE_AND_YEAR: 'ddd D MMMM YYYY',
    NICE_DAY_TEXT_TIME: 'ddd H:mm',
    NICE_DATE_TIME: 'DD-MM-YYYY HH:mm',
    NICE_DATE_TIME_SHORT: 'DD-MM-YY HH:mm',
    NICE_DATE_TIME_WITHOUT_YEAR: 'DD-MM HH:mm',
  },
}
